import { all, call, takeLatest, getContext, put } from 'redux-saga/effects';

import { push } from 'connected-react-router';

import { Logger } from '../../utils/Logger';

import { inviteRequest, inviteSignUp, inviteHashSignUp, rejectInvite } from './types';

import {
  requestInviteSuccess,
  requestInviteFailure,
  completeInviteSignUpSuccess,
  completeInviteSignUpFailure,
  requestRejectInviteSuccess,
  requestRejectInviteFailure,
} from './reducer';

import { onLoginSuccess } from '../auth/sagas';

const logger = new Logger('Saga:Invite');

export function* inviteRequestSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.get,
      routerService.generate('api.invite.get_invite', { token: action.token }),
    );

    yield put(requestInviteSuccess(response.data));
  } catch (error) {
    logger.error('Failed to get invite', error);
    yield put(requestInviteFailure(error));
  }
}

export function* completeInviteSignUpSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');
  const sessionService = yield getContext('sessionService');

  try {
    const response = yield call(
      authApiService.post,
      routerService.generate('api.platform.alpha_auth_signup_token', { token: action.token }),
      action.payload,
    );
    const tokenPayload = sessionService.decodeToken(response.data.token.access_token);
    yield call(
      onLoginSuccess,
      {
        accessToken: response.data.token.access_token,
        expiresAt: tokenPayload.exp,
        payload: tokenPayload,
        tokenPayload,
      },
      false,
    );
    yield put(completeInviteSignUpSuccess(response.data));
    yield put(push('/dashboard'));
  } catch (error) {
    logger.error('Failed to complete signup', error);
    yield put(completeInviteSignUpFailure(error));
  }
}

export function* completeInviteHashSignUpSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');
  const sessionService = yield getContext('sessionService');

  try {
    const response = yield call(
      authApiService.post,
      routerService.generate('api.invite.signup', { token: action.token }),
      action.payload,
    );
    const tokenPayload = sessionService.decodeToken(response.data.accessToken);
    yield call(
      onLoginSuccess,
      {
        accessToken: response.data.accessToken,
        expiresAt: tokenPayload.exp,
        payload: tokenPayload,
        tokenPayload,
      },
      false,
    );
    yield put(completeInviteSignUpSuccess(response.data));
    yield put(push('/dashboard'));
  } catch (error) {
    logger.error('Failed to complete signup', error);
    yield put(completeInviteSignUpFailure(error));
  }
}

export function* requestRejectInviteSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.patch,
      routerService.generate('api.invite.reject', { token: action.token }),
    );

    yield put(requestRejectInviteSuccess(response.data));
  } catch (error) {
    logger.error('Failed to complete signup', error);
    yield put(requestRejectInviteFailure(error));
  }
}

export default function* inviteSaga() {
  return yield all([
    takeLatest(inviteRequest.request, inviteRequestSaga),
    takeLatest(inviteSignUp.request, completeInviteSignUpSaga),
    takeLatest(inviteHashSignUp.request, completeInviteHashSignUpSaga),
    takeLatest(rejectInvite.request, requestRejectInviteSaga),
  ]);
}
